<svg
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 16 14">
    <path d="M16 12v1h-16v-12h1v11h15zM15 2.25v3.398q0 0.164-0.152 0.23t-0.277-0.059l-0.945-0.945-4.945 4.945q-0.078 0.078-0.18 0.078t-0.18-0.078l-1.82-1.82-3.25 3.25-1.5-1.5 4.57-4.57q0.078-0.078 0.18-0.078t0.18 0.078l1.82 1.82 3.625-3.625-0.945-0.945q-0.125-0.125-0.059-0.277t0.23-0.152h3.398q0.109 0 0.18 0.070t0.070 0.18z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-line-chart.html